import { TypeChecker } from '@attain-apps/type-guards'

export type Options = Options.Numerical | Options.Date
export namespace Options {
  export const isOptions = TypeChecker.Factory.lazy(() =>
    TypeChecker.Factory.union(Numerical.isNumerical, Date.isDate),
  )

  export type Numerical = Numerical.Precision | Numerical.Decimal
  export namespace Numerical {
    export const isNumerical = TypeChecker.Factory.lazy(() =>
      TypeChecker.Factory.union(Precision.isPrecision, Decimal.isDecimal),
    )

    export interface Decimal {
      min?: number
      max?: number
    }
    export namespace Decimal {
      export const isDecimal = TypeChecker.Factory.object({
        max: TypeChecker.Factory.optional(TypeChecker.isNumber),
        min: TypeChecker.Factory.optional(TypeChecker.isNumber),
      })
    }

    export type Precision = number
    export namespace Precision {
      export const isPrecision = TypeChecker.isNumber
    }
  }

  export type Date = string
  export namespace Date {
    export const isDate = TypeChecker.isString
  }
}
